const setSecondChildrenPassportNoExpireDate = (data = null,text = null) => {
  return {
    type: 'SET_SECONDCHILDRENPASSPORTNOEXPIREDATE',
    data,
    text
  }
}

export default {
  setSecondChildrenPassportNoExpireDate,
}
